/**
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema Golden Sisters
 * Arquivo: src/pages/admin/GrantAdminPage.js
 * Versão: 1.1 - CORREÇÃO CRÍTICA DE IMPORTAÇÃO: Removida a importação direta de 'functions' para usar a função 'grantMySelfAdmin' do firestoreService.
 * Data: 20 de julho de 2025
 * Responsável pela Alteração: Gemini (Arquiteto-Chefe)
 */
import React, { useState } from 'react';
// REMOVIDA: import { functions } from '../../firebase/config'; // Removida importação incorreta
// REMOVIDA: import { httpsCallable } from 'firebase/functions'; // Não é mais necessário importar httpsCallable diretamente aqui.
import { ShieldCheck, Loader2 } from 'lucide-react';

// Importa a função grantMySelfAdmin do seu serviço de Firestore
import { grantMySelfAdmin } from '../../services/firestoreService'; // ASSUMIDO: grantMySelfAdmin é uma callable function exportada de firestoreService

const GrantAdminPage = () => {
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleGrantAdmin = async () => {
        setIsLoading(true);
        setMessage('');
        setError('');
        try {
            // A chamada à Cloud Function 'grantMySelfAdmin' deve ser feita através do serviço
            const result = await grantMySelfAdmin();
            setMessage(result.message); // Use result.message diretamente
            console.log("Sucesso ao conceder admin:", result); // Log do objeto completo retornado
        } catch (err) {
            console.error("Erro ao conceder admin:", err);
            setError(err.message || 'Ocorreu uma falha.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-xl shadow-md text-center">
                <ShieldCheck className="w-16 h-16 mx-auto text-blue-600" />
                <h1 className="text-2xl font-bold text-gray-800">Conceder Acesso de CEO</h1>
                <p className="text-gray-600">
                    Clique no botão abaixo para atribuir o papel de Administrador (CEO) ao seu usuário logado.
                    Esta é uma operação de segurança crítica.
                </p>
                <button
                    onClick={handleGrantAdmin}
                    disabled={isLoading}
                    className="w-full px-4 py-3 font-semibold text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-gray-400 flex items-center justify-center transition-colors"
                >
                    {isLoading ? <Loader2 className="animate-spin mr-2" /> : <ShieldCheck className="mr-2" />}
                    Tornar-me Administrador
                </button>
                {message && <p className="mt-4 text-green-600 font-semibold">{message}</p>}
                {error && <p className="mt-4 text-red-600 font-semibold">{error}</p>}
            </div>
        </div>
    );
};

export default GrantAdminPage;